<template>
  <div class="">
    <div v-if="menuItems.length > 0 && $isMobile.value">
      <SubMenu :sub-menu-items="menuItems" />
      <slot name="subMenuAdditionalContent" />
    </div>

    <div class="flex w-full min-w-full justify-center">
      <div class="mb-4 w-full max-w-5xl md:m-4">
        <slot name="headerContent" />
        <div>
          <div
            v-if="!$isMobile.value && menuItems.length > 0"
            class="relative z-10 mx-auto text-gray-800 md:mt-2"
          >
            <slot name="subMenuAdditionalContent" />
            <SubMenu :sub-menu-items="menuItems" />
          </div>

          <div class="md:mt-4">
            <router-view />
          </div>
        </div>
        <slot name="mainContent" />
      </div>
    </div>
  </div>
</template>

<script>
import SubMenu from '@/app/shared/components/base/menu/subMenu.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'HorizontalBarItemMainPage',

  components: {
    SubMenu,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    isMobile() {
      return this.$isMobile.value || this.$isMobileApp;
    },
    ...mapState({
      coverUrl: state => state.club.coverUrl,
    }),

    ...mapGetters({
      currentTheme: 'getCurrentTheme',
    }),
  },

  watch: {},

  mounted() {},

  methods: {},
};
</script>
